<template>
  <div>
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: 30px auto;"
    />
    <div style="color: #4ae387;" v-if="confirmEmailSuccessResponse !== null">
      {{confirmEmailSuccessResponse}}
    </div>
    <form v-if="!this.$store.getters.isLoading" @submit.prevent="onsubmit">
      {{ $t('emails.confirmEmail') }}
      <div class="d-flex justify--center mt-3">
        <va-button :disabled="confirmEmailSuccessResponse !== null" type="submit" class="my-0" style="background-image: unset; background-color: rgb(108, 127, 238); box-shadow: rgb(10 13 117 / 25%) 0 1px 1px 0;">{{ $t('emails.requestEmail') }}</va-button>
      </div>
    </form>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
export default {
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  name: 'EmailConfirmationPrompt',
  data () {
    return {
      confirmEmailSuccessResponse: null,
    }
  },
  methods: {
    async successHandler (response) {
      this.confirmEmailSuccessResponse = response.data.message
      this.$store.commit('setLoading', false)
      await this.$router.push({ name: 'login' })
    },
    onsubmit () {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('confirmEmailRequest').then((resp) => this.successHandler(resp)).catch((err) => this.errorHandler(err.response))
    },
  },
  mounted () {
  },
}
</script>

<style scoped>

</style>
